<button class="ml-auto mt-3 mr-5" (click)="closeDialog()"><i class="fa-light fa-xmark text-3xl text-white"></i></button>
<div class=" w-full h-full flex items-center justify-center flex-col p-4">
    <p *ngIf="!isGroup">¿Estás seguro de que deseas eliminar el perfil <span class="text-accent text-2xl">{{ data.profile.name }}</span> ?</p>
    <p *ngIf="isGroup">¿Estás seguro de que deseas eliminar el grupo <span class="text-accent text-2xl">{{ data.profile.name }}</span> ?</p>
    <div class="flex justify-around mt-6 w-full">
        <button class="border-accent text-accent" (click)="closeDialog()">Cancelar</button>
        <button class="border-danger text-danger" (click)="deleteProfile()">Eliminar</button>
    </div>
</div>
